var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPresaleEnded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 128,
  height: 128,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__a)",
  d: "M94.195 98.824q-.652.648-1.574.982l-.62.186s-83.489 33.686-89.98 27.171c-6.493-6.516 27.497-89.882 27.497-89.882l.188-.618a4.3 4.3 0 0 1 .989-1.57c5.193-5.176 23.62 4.895 41.155 22.494 17.534 17.599 27.538 36.062 22.345 41.236"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__b)",
  d: "M89 101.189a1201 1201 0 0 1-23.58 9.051 871 871 0 0 1-20.204 7.249c-6.03 2.073-12.024 4.038-17.548 5.694a174 174 0 0 1-11.26-10.356 174 174 0 0 1-10.315-11.298c1.676-5.517 3.663-11.505 5.758-17.527a871 871 0 0 1 7.322-20.177c3.898-10.375 7.38-19.16 9.137-23.548 11.203 6.075 23.173 15.059 34.445 26.372C74.026 77.962 82.967 89.965 89 101.189"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__c)",
  d: "M94.194 98.823a4.3 4.3 0 0 1-1.574.984l-.618.184s-1.08.436-3.002 1.198a1201 1201 0 0 1-23.58 9.051 871 871 0 0 1-20.204 7.249c-5.998-4.523-12.01-9.749-17.835-15.596-5.824-5.846-11.028-11.877-15.53-17.891a871 871 0 0 1 7.322-20.177c3.898-10.375 7.379-19.16 9.137-23.548.77-1.919 1.209-2.997 1.209-2.997l.187-.617a4.3 4.3 0 0 1 .99-1.57c5.193-5.176 23.618 4.896 41.154 22.493 17.534 17.6 27.538 36.062 22.344 41.237"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__d)",
  d: "M94.194 98.823a4.3 4.3 0 0 1-1.574.984l-.618.184s-1.08.436-3.002 1.198a1201 1201 0 0 1-23.58 9.051c-8.456-5.569-17.118-12.626-25.4-20.939s-15.309-17-20.847-25.476c3.898-10.375 7.38-19.16 9.137-23.548.77-1.919 1.21-2.997 1.21-2.997l.186-.617a4.3 4.3 0 0 1 .99-1.57c5.193-5.176 23.618 4.896 41.154 22.493 17.534 17.6 27.538 36.062 22.344 41.237"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__e)",
  d: "M94.194 98.824C88.999 104 70.574 93.93 53.038 76.33 35.504 58.731 25.5 40.269 30.694 35.093c5.195-5.176 23.62 4.895 41.156 22.494 17.534 17.599 27.539 36.061 22.344 41.237"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__f)",
  d: "M90.957 94.08c-3.838 3.825-19.38-5.552-34.714-20.942s-24.654-30.966-20.817-34.79c3.838-3.824 19.38 5.553 34.714 20.943s24.654 30.966 20.817 34.79"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__g)",
  d: "M94.195 98.825c5.193-5.175-4.81-23.638-22.345-41.237-10.282-10.32-20.87-18.048-28.917-21.635q.47.868 1.057 1.717a14.5 14.5 0 0 0 2.221 2.51l4.453 4.484c-.513.233-.985.417-1.382.557a1.51 1.51 0 0 0-.977 1.723l1.576 7.826c.14.692.625 1.218 1.231 1.447L93.86 99.121q.176-.138.335-.296"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__h)",
  d: "m65.77 74.509 4.373 5.227 20.37 20.443c1.556-.044 2.807-.482 3.681-1.353 4.54-4.523-2.527-19.192-16.083-34.564a54 54 0 0 0-11.97 6.912 2.32 2.32 0 0 0-.37 3.334"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__i)",
  d: "m70.143 79.734-4.372-5.227a2.32 2.32 0 0 1 .37-3.334A53.88 53.88 0 0 1 113.78 62.2a54 54 0 0 1 11.824 4.977 2.32 2.32 0 0 1 .811 3.256l-3.637 5.763a2.32 2.32 0 0 1-3.098.782 42.7 42.7 0 0 0-9.064-3.776 42.45 42.45 0 0 0-37.299 6.894 2.32 2.32 0 0 1-3.174-.363"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__j)",
  d: "m32.358 25.467-3.97-4.085c-1.8-1.852-2.341-4.832-1.29-7.099 1.22-2.631 4.148-3.403 6.506-1.714 2.03 1.455 3.028 4.316 2.374 6.814l-1.442 5.51a1.293 1.293 0 0 1-2.178.574"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__k)",
  d: "m25.336 29.904-5.638-.82c-2.555-.37-4.801-2.404-5.35-4.84-.636-2.83 1.215-5.227 4.114-5.325 2.497-.085 5.03 1.576 6.035 3.955l2.215 5.248a1.292 1.292 0 0 1-1.376 1.782"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__l)",
  d: "m100.816 95.434 5.673-.513c2.572-.233 5.229 1.222 6.329 3.465 1.276 2.605.033 5.365-2.764 6.135-2.409.662-5.259-.364-6.789-2.444l-3.374-4.59a1.293 1.293 0 0 1 .925-2.053"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__m)",
  d: "m101.789 87.186 4.185-3.865c1.897-1.752 4.891-2.217 7.13-1.11 2.599 1.287 3.296 4.234 1.547 6.549-1.506 1.993-4.391 2.917-6.871 2.2l-5.473-1.583a1.293 1.293 0 0 1-.518-2.191"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__n)",
  d: "M52.394 56.25a1.956 1.956 0 0 1-2.513-1.48l-1.576-7.827a1.51 1.51 0 0 1 .977-1.722c.83-.293 1.983-.774 3.175-1.507-3.6-1.188-6.529-3.249-8.467-6.044-3.654-5.272-3.94-11.214-.766-15.895 3.14-4.632 8.943-6.891 14.44-5.622 6.011 1.387 10.233 6.646 11.294 14.067q.066.465.117.923c1.475-.864 2.666-1.93 3.412-3.123 1.889-3.018 2.068-7.524.457-11.478-1.022-2.51-2.6-4.428-4.38-5.393-.795-.43-1.218-1.324-1.005-2.202l1.805-7.443C69.64.364 70.854-.292 71.95.128c5.052 1.934 9.209 6.237 11.596 12.094 2.999 7.361 2.48 15.74-1.354 21.87-3.033 4.849-8.628 8.466-15.098 9.995-1.453 3.038-3.628 5.707-6.48 7.894-3.046 2.334-6.201 3.619-8.22 4.27m2.244-28.993c-.748-.002-1.552.371-1.94.942-.578.853.19 2.214.7 2.95.7 1.007 2.326 1.76 4.375 2.096q-.045-.684-.147-1.404c-.366-2.557-1.314-4.252-2.536-4.534a2 2 0 0 0-.452-.05"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__o)",
  d: "m77.28 39.378-8.205-8.235s.524 7.952-1.98 12.943c3.814-.901 7.325-2.53 10.186-4.708"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__p)",
  d: "M53.398 31.149c-.373-.539-.883-1.413-.903-2.177l-11.463-.02c.018 2.9 1.008 5.905 2.958 8.718 1.938 2.796 4.867 4.857 8.467 6.045 0 0 5.875-1.782 5.316-10.47-2.05-.336-3.676-1.088-4.375-2.096"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__q)",
  d: "M77.705 57.218a22.6 22.6 0 0 0-6.65 6.69.992.992 0 0 1-1.664-.003 22.6 22.6 0 0 0-6.626-6.715.992.992 0 0 1 .003-1.652 22.6 22.6 0 0 0 6.65-6.69.992.992 0 0 1 1.664.003 22.6 22.6 0 0 0 6.626 6.715.992.992 0 0 1-.003 1.652"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__r)",
  d: "M126.36 53.72a22.6 22.6 0 0 0-6.651 6.69.992.992 0 0 1-1.663-.003 22.6 22.6 0 0 0-6.627-6.715.993.993 0 0 1 .003-1.652 22.6 22.6 0 0 0 6.651-6.69.993.993 0 0 1 1.664.003 22.6 22.6 0 0 0 6.626 6.715.992.992 0 0 1-.003 1.651"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__s)",
  d: "M103.575 14.858a22.6 22.6 0 0 0-6.651 6.69.992.992 0 0 1-1.664-.003 22.6 22.6 0 0 0-6.626-6.714.992.992 0 0 1 .003-1.652 22.6 22.6 0 0 0 6.65-6.69.992.992 0 0 1 1.664.003 22.6 22.6 0 0 0 6.627 6.714.993.993 0 0 1-.003 1.652"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__t)",
  d: "M101.109 41.656a16.45 16.45 0 0 0-4.849 4.876.723.723 0 0 1-1.212-.002 16.45 16.45 0 0 0-4.83-4.895.723.723 0 0 1 .002-1.204 16.45 16.45 0 0 0 4.848-4.877.723.723 0 0 1 1.213.003 16.5 16.5 0 0 0 4.83 4.894.723.723 0 0 1-.002 1.205"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#presale-ended_svg__u)",
  d: "M109.009 26.6a16.45 16.45 0 0 0-4.848 4.878.724.724 0 0 1-1.213-.003 16.45 16.45 0 0 0-4.83-4.894.723.723 0 0 1 .002-1.204 16.45 16.45 0 0 0 4.848-4.877.724.724 0 0 1 1.213.002 16.45 16.45 0 0 0 4.83 4.895.723.723 0 0 1-.002 1.204"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__a",
  x1: 17.691,
  x2: 54.843,
  y1: 62.614,
  y2: 116.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE548"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#FFDE50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.445,
  stopColor: "#FFCA65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.771,
  stopColor: "#FFAA87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF90A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__b",
  x1: 46.631,
  x2: 39.458,
  y1: 104.528,
  y2: 129.783,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBA5C2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.386,
  stopColor: "#FCA0BA",
  stopOpacity: 0.386
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.974,
  stopColor: "#FF91A5",
  stopOpacity: 0.974
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF90A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__c",
  x1: 53.837,
  x2: 44.954,
  y1: 89.466,
  y2: 121.331,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBA5C2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.386,
  stopColor: "#FCA0BA",
  stopOpacity: 0.386
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.974,
  stopColor: "#FF91A5",
  stopOpacity: 0.974
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF90A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__d",
  x1: 59.735,
  x2: 48.639,
  y1: 72.159,
  y2: 108.429,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBA5C2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.386,
  stopColor: "#FCA0BA",
  stopOpacity: 0.386
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.974,
  stopColor: "#FF91A5",
  stopOpacity: 0.974
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF90A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__e",
  x1: 66.048,
  x2: 54.293,
  y1: 58.839,
  y2: 85.272,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE548"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#FFDE50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.445,
  stopColor: "#FFCA65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.771,
  stopColor: "#FFAA87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF90A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__f",
  x1: 54.961,
  x2: 71.547,
  y1: 78.814,
  y2: 53.409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD00D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DB722B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__g",
  x1: 70.326,
  x2: 59.96,
  y1: 67.674,
  y2: 35.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD00D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DB722B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__h",
  x1: 82.647,
  x2: 74.28,
  y1: 85.227,
  y2: 71.473,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A34A9E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#343168"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__i",
  x1: 95.82,
  x2: 96.201,
  y1: 80.925,
  y2: 59.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A34A9E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#343168"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__j",
  x1: 30.334,
  x2: 34.943,
  y1: 17.871,
  y2: 19.877,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3FA9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666AD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__k",
  x1: 19.209,
  x2: 24.083,
  y1: 25.069,
  y2: 23.851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A34A9E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#343168"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__l",
  x1: 107.54,
  x2: 95.485,
  y1: 98.751,
  y2: 106.019,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4974"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#FE4773"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.629,
  stopColor: "#FC406D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#F73464"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.868,
  stopColor: "#F12257"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.961,
  stopColor: "#E80C46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4003D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__m",
  x1: 109.712,
  x2: 104.084,
  y1: 83.814,
  y2: 99.914,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4F8B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B8EAC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__o",
  x1: 78.666,
  x2: 60.504,
  y1: 45.286,
  y2: 32.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4003D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.343,
  stopColor: "#CD0E2D",
  stopOpacity: 0.343
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#972E07"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__p",
  x1: 51.102,
  x2: 56.18,
  y1: 35.905,
  y2: 40.621,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4003D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.343,
  stopColor: "#CD0E2D",
  stopOpacity: 0.343
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#972E07"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__q",
  x1: 67.647,
  x2: 76.019,
  y1: 52.938,
  y2: 64.147,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3FA9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666AD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__r",
  x1: 116.303,
  x2: 124.675,
  y1: 49.448,
  y2: 60.658,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3FA9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666AD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__s",
  x1: 93.524,
  x2: 101.896,
  y1: 10.583,
  y2: 21.793,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A34A9E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#343168"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__t",
  x1: 93.777,
  x2: 99.88,
  y1: 38.544,
  y2: 46.715,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4F8B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B8EAC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "presale-ended_svg__u",
  x1: 101.68,
  x2: 107.783,
  y1: 23.49,
  y2: 31.662,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE548"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#FFDE50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.445,
  stopColor: "#FFCA65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.771,
  stopColor: "#FFAA87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF90A4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "presale-ended_svg__n",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(.115 -4659.565 21396.228)scale(50.3864)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4974"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#FE4773"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.629,
  stopColor: "#FC406D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#F73464"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.868,
  stopColor: "#F12257"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.961,
  stopColor: "#E80C46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4003D"
})))));
export default SvgPresaleEnded;